import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import DataFinancialReportChannelWise from "../Reoprts/data-financial-report-channel-wise";
// import FinancialReport from "../Reoprts/financial-report";

const ViewContact = Loadable(lazy(() => import("../ContactList/contact-view/view-contact")));
const Dashboard = Loadable(lazy(() => import("../Dashboard")));
// const UserDashboard = Loadable(lazy(() => import("../User Dashboard")));
const CampaignCreation = Loadable(lazy(() => import("../Campaigns/campaign-create/campaign-create")));
const ManageCampaignsUses = Loadable(lazy(() => import("../Campaigns/campaign-uses/campaign-uses")));
const CampaignView = Loadable(lazy(() => import("../Campaigns/campaign-uses/view-uses/campaign-uses-view")));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const ManageContactList = Loadable(lazy(() => import("../ContactList")));
const FinancialReportChannelWise = Loadable(lazy(() => import("../Reoprts/financial-report-channel-wise")));
const CampaignListReport = Loadable(lazy(() => import("../Reoprts/campaign-list-report")));

function UserAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
          // element: <UserDashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
          // element: <UserDashboard />,
        },
        {
          path: "campaign",
          children: [
            {
              path: "creation",
              element: <CampaignCreation role={role} />,
            },
            {
              path: "list",
              element: <ManageCampaignsUses />,
            },
            {
              path: "view/:type/:id",
              element: <CampaignView />,
            },
          ],
        },
        {
          path: "contact",
          children: [
            {
              path: "list",
              element: <ManageContactList role={role} />,
            },
            {
              path: "view/:id",
              element: <ViewContact />,
            },
          ],
        },
        // {
        //     path: 'black-list',
        //     element: <BlackList role={role}/>
        // },
        {
          path: "reports",
          children: [
            {
              path: "campaign-list",
              element: <CampaignListReport />,
            },
            // {
            //     path: 'financial-report',
            //     element: <FinancialReport/>
            // },
            {
              path: "financial-report",
              element: <FinancialReportChannelWise />,
            },
            {
              path: "reward-financial-report",
              element: <DataFinancialReportChannelWise />,
            },
          ],
        },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default UserAuthorizedRoutes;
